<template>
  <div class="home">
    <!-- <v-header @changeTab="changTab"></v-header> -->
    <el-container>
      <el-aside width="110px">
        <v-sidebar v-bind:class="{'sidebar' : isShow,'hideSidebar':isHide}"></v-sidebar>
      </el-aside>
      <el-main >
        <div v-bind:class="{'mains':isShow,'hideMains':isHide}"  id="main_div">
          <keep-alive exclude="Msglist,MsgSidebar,MsgHome,speakMeetingHome,OperationList,OperationDetail,clientConsult,ConsultDetail,vip,pendingList,processed,electronInductionManagement">
            <router-view/>
          </keep-alive>
        </div>
      </el-main>
    </el-container>




    <!-- <v-sidebar v-bind:class="{'sidebar' : isShow,'hideSidebar':isHide}"></v-sidebar>
    <div v-bind:class="{'mains':isShow,'hideMains':isHide}" :style="fullHeight" style="background-color:#F5F6FA;min-height:614px;" id="main_div">
      <keep-alive exclude="Msglist,MsgSidebar,MsgHome">
        <router-view/>
      </keep-alive>
    </div> -->
    <!-- <v-footer></v-footer> -->

    <!--  提示‘请前往APP签署自保件承诺书’的弹框  -->
    <el-dialog title="提示"
               :visible.sync="dialogVisible"
               :show-close=false
               :close-on-click-modal=false
               :close-on-press-escape=false
               :append-to-body=true width="30%">
      <span>请前往APP签署自保件承诺书</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="logOut()">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/*
   * 导入
   * 头部、
   * footer、
   * 面包屑
   * 模块
   * */
import vHeader from '@/layout/Header.vue'
import vSidebar from '@/layout/Sidebar.vue'
import vFooter from '@/layout/Footer.vue'
import api from '@/modules/api.js';
import url from '@/modules/url.js';
import {showFullScreenLoading, tryHideFullScreenLoading} from '@/components/utils/loading.js'
//  import vFooter from "@/components/manage/layout/Footer.vue"
//  import vCrumbnav from "@/layout/Crumbnav.vue"

export default {
//        组件名称
  name: 'Home',
  //        导入相关模块
  components: {vHeader, vSidebar,vFooter},
  //        初始化变量
  data () {
    /// /            返回值
    return {
      //                初始化高度，后期可变
      fullHeight: {height: ''},
      heightSize:'',
      mainHeight:'',
      //                默认显示
      isShow: true,
      //                默认隐藏
      isHide: false,
      dialogVisible: false, // 控制显示或隐藏‘请前往APP签署自保件承诺书’弹窗的变量
    }
  },
  //        页面加载完渲染
  created () {
    /// /            this.changTab()
    /// /            获取高度
    this.height()
    //    },
    /// /        一直在执行
    //    updated(){ this.height()
  },
  methods: {
    //            判断跳转路径
    changTab (v) {
      if (v === 'system') { this.$router.push({path: '/manage/system'}) } else {
        this.$router.push({path: '/manage/page_model'})
      }
    },
    //            获取高度
    //height () { this.fullHeight.height = window.innerHeight - 70 + 'px' }
    height () {
      this.fullHeight.height = window.innerHeight + 'px'
      this.heightSize = window.innerHeight + 'px'

      // alert(document.body.scrollHeight)
    },
    //            控制隐藏和显示

    /**
     * @Description: 页面初始化判断是否签署过承诺书的方法
     * @author:zhangqi
     * @Date:2022-03-07
     */
    checkPayPromiseBookSignFunc(){
      api.post(url.checkPayPromiseBookSign, {}, res=> {
        if(!res.data.isSign){
          this.dialogVisible = true
        }
      });
    },

    /**
     * @Description: 点击弹窗中‘我知道了’按钮，执行退出系统的方法
     * @author:zhangqi
     * @Date:2022-03-07
     */
    logOut () {
      window.sessionStorage.removeItem('sidebar_active');
      this.delCookie('jtl')
      this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]
      // window.location.href = 'https://testsso.ihasl.com/SSO2/SSO-JTL2.html?service=' + encodeURIComponent('https://testsso.ihasl.com/HASLSSO2/logout?service=' + encodeURIComponent(this.homePage + '/pages/salessupport/pc/index.html#/'))
      window.location.href = this.$logOutFront + encodeURIComponent(this.$logOutBack + encodeURIComponent(this.homePage + this.$address))
    },
    delCookie (key) {
      var date = new Date()
      date.setTime(date.getTime() - 1)
      var delValue = this.getCookie(key)
      if (delValue) {
        document.cookie = key + '=' + delValue + ';expires=' + date.toGMTString()
      }
    },
    getCookie (key) {
      var arr, reg = RegExp('(^| )' + key + '=([^;]+)(;|$)')
      if (arr = document.cookie.match(reg)) // ["username=liuwei;", "", "liuwei", ";"]
      { return decodeURIComponent(arr[2]) } else { return null }
    }
  },
  mounted () {
    // if(sessionStorage.getItem('mainHeight')) {
    //   this.mainHeight = sessionStorage.getItem('mainHeight')
    // }else {
    //   showFullScreenLoading()
    //   setTimeout(() => {
    //     this.mainHeight = document.querySelector('.el-main').clientHeight + 'px'
    //     tryHideFullScreenLoading()
    //   },2000)
    // }
      // alert(this.mainHeight)
    /// /            获取浏览器改变是高度
    const that = this

    //            浏览器方法
    // window.onresize = () => {
    //   this.height()


    // }
    // 调用页面初始化判断是否签署过承诺书的方法
    that.checkPayPromiseBookSignFunc()
  },
  //        监视屏幕大小改变
  watch: {
    $route(to,from){
      // console.log(to.meta.keepAlive);
      // alert(to.name)
      console.log(to)
      //  alert("toname:"+to.name+",formname:"+from.name)
      // if((from.name=="getPolicyListQuery" && to.name=="getPolicyList") || (to.name=="getPolicyListQuery" && from.name=="getPolicyList")){
      // this.mainHeight = document.querySelector('.el-main').clientHeight + 'px'
      //sessionStorage.setItem('mainHeight',this.mainHeight)
      // alert(this.mainHeight)
      // alert(this.includestr)
      // this.iskeepAlive=to.meta.keepAlive
    }
    // fullHeight (val) {
    //   if (!this.timer) {
    //     this.fullHeight = val
    //     //                    一直在执行
    //     this.timer = true
    //     let that = this
    //     //                    400毫秒执行依稀
    //     setTimeout(function () { that.timer = false }, 400)
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
  body{
    margin:0;
  }
  .home{
    // height: 100vh;
    .el-container{
      height: 100%;
    }
  }
   .mains{
  height:100vh
  }

  /* .home{
    overflow: hidden;
  } */
  .el-aside{
    overflow: inherit;
  }
  .el-main{
    padding: 0;
    background-color:#F5F6FA;
    /* overflow: hidden; */
  }
  @media screen and (min-width: 1400px) {
     /* .mains{
      margin-left:5%;
      overflow: auto;
    } */
  }
</style>
<style>
.hidden{
  display: none;
}
.clear {
	clear: both;
	height: 0;
	font-size: 0;
	line-height: 0;
	overflow: hidden;
}
.pointer{
  cursor:pointer;
}
.conH{
  height:60px;
}
.floatRight{ float: right;}
.floatLeft{ float: left;}
@media screen and (max-width: 1024px){
  .conH{ height:50px;}
  #Activity{padding-top:50px !important;}
  /* #Activitycount{padding-top:50px !important;}
  #Activitypeople{padding-top:50px !important;} */
}

</style>



// WEBPACK FOOTER //
// src/pages/home.vue